import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";
import { HeaderSpacer } from "../../_layout-helpers/spacers";
import { HeaderComponent } from "../../../components/HeaderComponent/HeaderComponent";
import { Spacer } from "../../../components/_shared-components/arrangement/Space";
import { FooterComponent } from "../../../components/FooterComponent/FooterComponent";

import { CustomerServiceContactData } from "../../../components/_shared-components/CustomerServiceContactData";
import { PageMetadataComponent } from "../../../components/PageMetadataComponent/PageMetadataComponent";
import { CheckoutPageData, ExtractSwarovskiPageData, SwarovskiOptikShopLocaleFrontend } from "@swo/storefront";
import { ModalLoadingSpinner } from "../../../routes/modal-loading-spinner";
import { useStore } from "../../../store/hooks/use-store";

const Lazy_CheckoutComponent = React.lazy(() =>
  import("./CheckoutComponent/checkout-component").then(m => ({ default: m.CheckoutComponent })),
);

export const CheckoutPageLayout: ReactTFC<ExtractSwarovskiPageData<CheckoutPageData>> = props => {
  const { locationOrigin } = useStore().state;

  const returnUrl = new URL(props.data.links.purchaseConfirmationPage, locationOrigin);

  return (
    <React.Fragment>
      <PageMetadataComponent
        {...props.data.metadata}
        locationOrigin={locationOrigin}
        languageIsoCode={props.locale.language.isoCode}
      />

      <HeaderComponent header={props.data.header} version={"minimalistic"} floatingDisabled={true} />

      <React.Suspense fallback={<ModalLoadingSpinner />}>
        <Lazy_CheckoutComponent
          locale={props.locale as SwarovskiOptikShopLocaleFrontend}
          segment={props.segment}
          translations={props.data.translations}
          links={props.data.links}
          returnUrl={returnUrl}
          deliveryDaysRange={props.data.delivery.daysRange}
          eshopActiveLocalesList={props.data.eshopActiveLocalesList}
        >
          <CustomerServiceContactData
            contactData={props.data.contactData}
            headline={undefined}
            chatbotEnabled={props.locale.chatbotEnabled}
            noSpacing={true}
          />

          <Spacer size={"md"} />
        </Lazy_CheckoutComponent>

        <FooterComponent {...props.data.footer} simplified={true} />
      </React.Suspense>
    </React.Fragment>
  );
};
